import { ProductStatus } from '../entity/Product'
import { HubConnection } from '@microsoft/signalr'
import { AppDispatch } from '../types/store'
import { logOnSignalRMethodTrigger } from './lib/logOnSignalRMethodTrigger'
import { SignalRMethods } from './lib/SignalRMethods'
import { productsActions } from '../store/slices/productsSlice'

export const receiveProductStatus = (
    connection: HubConnection,
    dispatch: AppDispatch
) => {
    const productStatuses = Object.values(ProductStatus)

    connection.on(SignalRMethods.PRODUCT_STATUS, (productId, status) => {
        logOnSignalRMethodTrigger(
            SignalRMethods.PRODUCT_STATUS,
            productId,
            status
        )
        if (productId && productStatuses.includes(status)) {
            dispatch(productsActions.changeProductStatus({guid: productId, status}))
        }
    })
}
